import { logger } from '@/lib/logger';

import { ConsentPlugin } from '../types';

export function createNoopPlugin(): ConsentPlugin {
  return {
    init() {},
    hasConsent(category: string) {
      return category === 'essential';
    },
    setCookiesLanguage(languageCode: string) {
      logger.debug(String(languageCode));
    },
  };
}
